import { api as chatApi } from './auto-generated/chat'

chatApi.enhanceEndpoints({
  endpoints: {},
})

export { chatApi }
